import { Collapse } from "antd";
import React, { useRef, useEffect, useState, useContext } from "react";
import "./index.less";
import { useTranslation } from "react-i18next";
import IconFont from "../icon";
import colors from "../styles/colors";
import AttachmentComp from "./handleAttachment";
import { BusinessForm } from "@/utils/chat/message";

const { Panel } = Collapse;
export default function AttachmentItem({
  mode,
  disabled,
  uploaderProxy,
  multiple,
  fileList,
  businessForm,
  onAttachmentRemove,
  onAttachmentUploadFinish,
  task,
  openPreviewWps,
  uploadControlName,
  bizId
}: {
  mode: string;
  disabled: boolean;
  uploaderProxy: boolean;
  multiple: boolean;
  fileList: any[];
  businessForm: BusinessForm;
  onAttachmentRemove: (fileId: string) => void;
  onAttachmentUploadFinish: (file: any) => void;
  task?: boolean;
  openPreviewWps?: Function;
  uploadControlName?: string;
  bizId?: string;
}) {
  const { t } = useTranslation("work");
  const [attachmentMenuShowFn, setAttachmentMenuShowFn] = useState<Function>(() => () => {});
  let clicksign = false; // 记录是不是点击 label里的 ‘+ 添加附件’
  return (
    <div className="attachement-detail-area attachment-comp">
      <div className="attachment-detail-content-item task-attachment-item">
        <div
          className="label"
          style={{ alignSelf: "flex-start", marginRight: task ? "20px" : "6px" }}
        >
          <span>{t("attachment")}</span>({fileList?.length || 0})
        </div>
        {/* <Collapse
          defaultActiveKey={[0]}
          bordered={false}
          expandIconPosition="right"
          expandIcon={({ isActive }) => isActive && <div />}
          onChange={function name(params: any) {
            if (clicksign && params.length) {
              attachmentMenuShowFn(100);
            }
            clicksign = false;
          }}
        >
          <Panel
            header={
              <div className="label" style={{ alignSelf: "flex-start" }}>
                <b>{t("attachment")}</b>({fileList?.length || 0})
              </div>
            }
            key={0}
            forceRender={true}
          > */}
        <AttachmentComp
          disabled={disabled}
          mode={mode}
          businessForm={businessForm}
          uploaderProxy={uploaderProxy}
          multiple={multiple}
          onRemove={onAttachmentRemove}
          onFinish={onAttachmentUploadFinish}
          fileList={fileList}
          autoShowMenuFnSetter={setAttachmentMenuShowFn}
          openPreviewWps={openPreviewWps}
          uploadControlName={uploadControlName}
          bizId={bizId}
        >
          <div
            className="rg-handle"
            style={{
              marginRight: !fileList?.length ? "-6px" : ""
            }}
            onClick={function (a) {
              clicksign = true;
            }}
          >
            <IconFont
              className="lb-conclude"
              type="iconapp_btn_add2"
              style={{
                color: `#306FDC`,
                position: "static"
              }}
            />
            <em>添加附件</em>
          </div>
        </AttachmentComp>
        {/* </Panel>
        </Collapse> */}
      </div>
      {fileList.length === 0 && (
        <div className="center empty">暂无附件，可点击“添加附件”进行上传/创建</div>
      )}
    </div>
  );
}
